import { AreaField, Button, NumberField, SelectField, TextField } from 'ui-toolkit';
import { EscrowWireDisbursementCategoriesOptions } from '../../../../escrow/disbursements/achPushDisbursements/createWireFromACH/EscrowWireDisbursementCategoriesOptions';
import { checkForMutationSuccess } from 'API/checkForMutationSuccess';
import React, { useState } from 'react';
import {
  useCreateWireDisbursementFromACHMutation,
  useGetBankWireRoutingNumberQuery,
} from 'API/order/escrow/WireDisbursementAPI';
import { useDeleteAchDisbursementMutation } from 'API/order/escrow/AchDisbursementAPI';
import { IACHDisbursementFormData } from 'types/order/escrow/achDisbursements/IACHDisbursementFormData';

interface IConvertACHToWireForm {
  ach: IACHDisbursementFormData;
  isValid: boolean;
  onClose: () => void;
  orderId: string;
  values: any;
}

export const ConvertACHToWireForm: React.FC<IConvertACHToWireForm> = ({ ach, isValid, onClose, orderId, values }) => {
  const [onSaveWire] = useCreateWireDisbursementFromACHMutation();
  const [onDeleteACH] = useDeleteAchDisbursementMutation();
  const [routingNumber, setRoutingNumber] = useState<string | null>(null);

  const { data: bankName } = useGetBankWireRoutingNumberQuery(routingNumber ?? '', {
    skip: routingNumber?.length !== 9,
  });

  return (
    <>
      <div className={'my-4 flex basis-full flex-wrap'}>
        <TextField name="beneficiary_name" className={'basis-full'} label="Beneficiary Name" readOnly={true} />
        <div className={'flex basis-full flex-row gap-2 py-2'}>
          <NumberField className={'basis-1/2'} name="amount" label="Amount" mode="currency" />
          <SelectField
            className={'basis-1/2'}
            name="category"
            label="Category"
            options={EscrowWireDisbursementCategoriesOptions}
            isRequired
          />
        </div>
        <div className={'flex basis-full flex-row gap-2 pb-2'}>
          <TextField
            className={'basis-1/2'}
            name="routing_number"
            label="Wire ABA"
            autoFocus={true}
            hintText={bankName?.name}
            isRequired
            onChange={(value) => setRoutingNumber(value)}
          />
          <TextField className={'basis-1/2'} name="account_number" label="Account Number" readOnly={true} />
        </div>
        <AreaField className={'basis-full'} name={'memo'} label={'Memo Line'} maxCharacterCount={160} />
      </div>
      <div style={{ display: 'flex' }}>
        <Button
          data-test-id={'create-wire-button'}
          intent={'primary'}
          disabled={!isValid}
          type="button"
          onClick={async () => {
            const saveResult = await onSaveWire({
              orderId: orderId,
              ...(values as any),
            } as any);
            if (checkForMutationSuccess(saveResult, 'creating Wire from ACH')) {
              const deleteResult = await onDeleteACH({ orderId, achId: ach.id });
              if (checkForMutationSuccess(deleteResult, 'deleting ACH')) {
                onClose();
              }
            }
          }}
        >
          Create Wire
        </Button>
        <Button intent={'ghost'} onClick={onClose}>
          Cancel
        </Button>
      </div>
    </>
  );
};
